import React, { useEffect, useState } from 'react';

const PDFViewer = ({ pdfUrl }) => {
  const [blobUrl, setBlobUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  console.log('pdfUrl', pdfUrl);

  useEffect(() => {
    if (!pdfUrl) return;

    setLoading(true);
    fetch(pdfUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        setBlobUrl(url);
        setLoading(false);
      })
      .catch(err => {
        setError('Failed to load PDF');
        setLoading(false);
        console.error(err);
      });

    return () => {
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [pdfUrl]);

  if (loading) return <div>Loading PDF...</div>;
  if (error) return <div>{error}</div>;

  return (
    <object
      data={blobUrl}
      type="application/pdf"
      width="100%"
      height="100%"
      style={{display: "block"}}
    >
      <p>Unable to display PDF. <a href={pdfUrl} target="_blank" rel="noopener noreferrer">Click here to download.</a></p>
    </object>
  );
};

export default PDFViewer;